export { MobileInput, type MobileInputProps } from './MobileInput';
